// Admin -> Sheets import (4 qadam), uz
export default {
  title: "Sheets import",
  subtitle: "Joriy Google Sheets dan bir martalik ko'chirish · dasturchilar jamoasi bilan birga",
  ownerOnly: "Faqat egasi uchun",
  ownerOnlyDesc: "Ma'lumotni faqat egasi import qila oladi.",
  steps: { connect: "Jadvalni ulash", map: "Ustunlarni moslash", preview: "Tekshirish va dublikatlar", import: "Import" },
  connect: {
    fileRead: "Fayl o'qildi",
    fileReadDesc: "{{rows}} qator · {{cols}} ustun",
    fileFailed: "Faylni o'qib bo'lmadi.",
    pasteLink: "Google Sheets havolasini kiriting.",
    sheetConnected: "Jadval ulandi",
    sheetConnectedDesc: "{{rows}} qator",
    sheetFailed: "Jadvalga ulanib bo'lmadi.",
    uploadTitle: "Fayl yuklash",
    uploadDesc: "Google Sheets dan eksport qilingan CSV yoki XLSX",
    dropHere: "Faylni shu yerga tashlang yoki",
    browse: "tanlang",
    limit: "CSV yoki XLSX, 20 MB gacha",
    howTo: "Google Sheets da: File → Download → CSV (har varaq alohida fayl).",
    template: "Shablonni yuklab olish",
    readFile: "Faylni o'qish",
    linkTitle: "Google Sheets havolasi",
    linkDesc: "Jonli jadvalni Sheets API orqali ulash",
    sheetUrl: "Jadval URL",
    tabName: "Varaq nomi",
    tabHint: "Birinchi varaq uchun bo'sh qoldiring",
    shareWith: "Jadvalni shu manzilga ulashing:",
    notConfigured: "Google Sheets ulanishi hali sozlanmagan — o'rniga CSV/XLSX eksportini yuklang.",
    connectSheet: "Jadvalni ulash",
    googleConnected: "{{email}} nomidan o'qiladi",
    googleConnectedHint: "Jadval shu Google akkauntga tegishli bo'lishi yoki unga ulashilgan bo'lishi kerak.",
    googleReauth: "Google ruxsatining muddati tugagan.",
    googleReconnectLink: "Sozlamalar → Integratsiyalar bo'limida qayta ulash",
    googleNotConnected: "Google akkaunt ulanmagan.",
    googleConnectLink: "Sozlamalar → Integratsiyalar bo'limida ulash",
    googleOrShare: "Yoki jadvalni service account'ga ulashing:",
    previous: "Oldingi importlar",
    noImports: "Hali import yo'q.",
    col: { file: "Fayl / jadval", when: "Qachon", who: "Kim", status: "Holat", rows: "Qatorlar", imported: "Import qilindi", errors: "Xatolar" },
    importN: "Import #{{id}}",
  },
  status: { uploaded: "Yuklandi", mapped: "Moslandi", previewed: "Tekshirildi", importing: "Import qilinmoqda", done: "Tugadi", failed: "Xato" },
  map: {
    phoneRequired: "Telefon ustunini moslang: u majburiy.",
    usedTwice: "Bir maydon ikki marta ishlatilgan: {{fields}}.",
    saveFailed: "Moslikni saqlab bo'lmadi.",
    connected: "Ulandi:",
    rowsCols: "{{rows}} qator · {{cols}} ustun",
    tabs: "varaqlar: {{tabs}}",
    columnMapping: "Ustunlar mosligi",
    step2: "2-qadam",
    col: { sheet: "Jadval ustuni", sample: "Namuna qiymat", field: "Tizimdagi maydon", req: "Majb." },
    fieldFor: "{{col}} uchun maydon",
    yes: "ha",
    twice: "ikki marta",
    skipped: "o'tkazildi",
    ok: "✓ ok",
    phoneHint: "Telefon majburiy: telefon raqamlari bor ustunni tanlang.",
    statusValues: "Holat qiymatlari",
    statusSubtitle: "jadvalda {{n}} qiymat · {{unmapped}} moslanmagan",
    noStatusColumn: "Holat ustuni moslanmagan — hamma “Yangi” dan boshlaydi",
    inSheet: "Jadvalda",
    inSystem: "Tizimda",
    statusFor: "{{raw}} uchun holat",
    mapStatusHint: "Jadvaldagi so'zlarni voronka holatlariga o'girish uchun yuqorida biror ustunni “Holat” ga moslang.",
    owner: "Egasi",
    ownerDesc: "Import qilingan haydovchilar kimga tegadi",
    useColumn: "Recruiter ustunidan olish",
    useColumnHint: "Ism yoki email foydalanuvchiga moslanadi; topilmasa → quyidagi standart egasi.",
    useColumnMissing: "Avval biror ustunni “Recruiter (egasi)” ga moslang.",
    single: "Hammasini bitta recruiterga biriktirish",
    pool: "Egasiz (filial / jamoa umumiy ro'yxati)",
    poolHint: "Jamoa rahbari keyin taqsimlaydi.",
    recruiter: "Recruiter",
    defaultOwner: "Standart egasi (topilmagan ismlar uchun)",
    nonePool: "— yo'q (umumiy ro'yxat) —",
    branch: "Filial",
    choose: "— tanlang —",
    team: "Jamoa",
    branchPool: "— filial umumiy ro'yxati —",
    defaultSource: "Standart manba",
    defaultSourceHint: "Manba ustuni bo'sh yoki moslanmagan bo'lsa ishlatiladi",
    nothingWritten: "Import tugmasi bosilmaguncha hech narsa yozilmaydi.",
    back: "Orqaga",
    savePreview: "Moslikni saqlash va tekshirish",
  },
  preview: {
    imported: "{{n}} haydovchi import qilindi",
    failed: "Import bajarilmadi.",
    failedTitle: "Import bajarilmadi",
    step2done: "2-qadam, tayyor",
    ownerFrom: "Egasi:",
    ownerColumn: "Recruiter ustunidan",
    ownerSingle: "bitta recruiter",
    ownerPool: "filial / jamoa umumiy ro'yxati",
    unresolved: "{{n}} qatorda egasi topilmadi (umumiy ro'yxatga)",
    statusUnmapped: "{{n}} holat qiymati moslanmagan → Yangi",
    title: "Tekshirish",
    step3: "3-qadam",
    rowsFound: "Topilgan qatorlar",
    ready: "Importga tayyor",
    duplicates: "Birlashtirilgan dublikatlar",
    errors: "Xatolar (import qilinmaydi)",
    reformatted: "Qayta formatlangan telefonlar",
    whyFail: "{{n}} qator nega o'tmaydi",
    dupHint: "Dublikatlar: tizimda bor haydovchi (bir xil telefon yoki CDL) o'tkazib yuboriladi — mavjud yozuv egasi saqlanadi. Masalan, ikki recruiter jadvalidagi haydovchi bitta yozuv bo'ladi va uni birinchi qo'shgan recruiterga tegadi.",
    downloadErrors: "Xato qatorlarni yuklab olish",
    notImported: "Import qilinmagan qatorlar ({{n}})",
    notImportedDesc: "Birinchi 20 tasi ko'rsatilgan · jadvalda tuzating va qayta import qiling",
    col: { row: "Qator", reason: "Sabab", values: "Qiymatlar" },
    transaction: "Import tugmasi bosilmaguncha hech narsa yozilmaydi. Import bitta tranzaksiya: hamma qator yoki hech biri.",
    importing: "Import qilinmoqda…",
    importN: "{{n}} haydovchini import qilish",
  },
  done: {
    importing: "Import qilinmoqda…",
    failed: "Import bajarilmadi — hech narsa yozilmadi",
    unknown: "Noma'lum xato.",
    backToPreview: "Tekshiruvga qaytish",
    another: "Yangi import boshlash",
    imported: "{{n}} haydovchi import qilindi",
    history: "har haydovchi tarixida “… dan import qilindi” ko'rinadi",
    rowsFound: "Topilgan qatorlar",
    importedLabel: "Import qilindi",
    duplicates: "Birlashtirilgan dublikatlar",
    errors: "Xatolar (import qilinmaydi)",
    goDrivers: "Haydovchilarga o'tish",
  },
};
